module.exports = __webpack_public_path__ + "img/lightning.4bf30e54.svg";